<template>
  <div v-if="show" class="bg-course-alert bg-vice-rose-200">
    <div class="flex gap-3 justify-between px-2 py-3">
      <div class="flex">
        <div class="flex mr-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#fff08e"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>
        <div>
          <h3 class="text-sm font-semibold text-yellow-800">
            Complete the Professionalism Course Before Your VCE Session
          </h3>
          <div class="mt-2 text-sm text-yellow-800">
            <p>
              Before joining a VCE session, you'll need to complete the Professionalism course. It’s
              a 20–30 minute
              <br />
              course, and you’ll need to score 100% to move forward. Click
              <span class="font-medium">‘Take Course’</span>
              to get started!
              <br />
              Course completed? Refresh the dashboard to unlock session access.
            </p>
          </div>
        </div>
      </div>

      <div class="flex items-center">
        <div class="mx-2 my-1.5 flex w-max">
          <ViceButton :href="url" target="_blank" red>Take course</ViceButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViceButton from '@/Components/Buttons/ViceButton.vue';

export default {
  props: {
    show: {
      required: true,
      type: Boolean,
    },
    url: {
      type: String,
    },
  },
  components: {
    ViceButton,
  },
};
</script>

<style scoped>
.bg-course-alert {
  border: 3px solid #be3f3f;
}
</style>
